// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pi-8";
export var editMode = "_pi-3";
export var headerRow = "_pi-a";
export var headerTitle = "_pi-b";
export var product = "_pi-1";
export var productDetails = "_pi-5";
export var productDivider = "_pi-7";
export var productImage = "_pi-2";
export var productInfo = "_pi-4";
export var productTitle = "_pi-6";
export var strikethrough = "_pi-9";
export var upsellProductsCard = "_pi-0";